import { render, staticRenderFns } from "./ClientPayers.vue?vue&type=template&id=5e8ffafb&"
import script from "./ClientPayers.vue?vue&type=script&lang=js&"
export * from "./ClientPayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports